import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";

export function useCourses(isAdmin) {
  const [courses, setCourses] = useState([]);
  const [cohorts, setCohorts] = useState([]);
  const [loadingCourses, setLoadingCourses] = useState(false);

  const createCourse = async ({
    courseName,
    courseType,
    description,
    price,
    durationDays,
    freeQuestionBankDays,
    }) => {
    if (!courseName || !courseType) {
        alert("Course name and course type are required.");
        return false;
    }

    const { error } = await supabase.from("courses").insert({
        course_name: courseName,
        course_type: courseType,
        description,
        price: price ? Number(price) : null,
        duration_days: durationDays ? Number(durationDays) : null,
        free_question_bank_days: freeQuestionBankDays
        ? Number(freeQuestionBankDays)
        : null,
        status: "active",
    });

    if (error) {
        alert(error.message);
        return false;
    }

    await fetchCoursesAndCohorts();
    alert("Course created.");
    return true;
    };

const createCohort = async ({
    courseId,
    cohortName,
    status,
    startDate,
    endDate,
    description,
    maxStudents,
    instructorName,
    meetingSchedule,
    location,
    }) => {
    if (!courseId || !cohortName) {
        alert("Course and cohort name are required.");
        return false;
    }

    const { error } = await supabase.from("cohorts").insert({
        course_id: courseId,
        cohort_name: cohortName,
        start_date: startDate || null,
        end_date: endDate || null,
        description,
        status: status || "planned",
        max_students: maxStudents ? Number(maxStudents) : null,
        instructor_name: instructorName,
        meeting_schedule: meetingSchedule,
        location,
    });

    if (error) {
        alert(error.message);
        return false;
    }

    await fetchCoursesAndCohorts();
    alert("Cohort created.");
    return true;
    };

  const fetchCoursesAndCohorts = async () => {
    if (!isAdmin) return;

    setLoadingCourses(true);

    const { data: courseData, error: courseError } = await supabase
      .from("courses")
      .select("*")
      .order("created_at", { ascending: false });

    if (courseError) {
      alert(courseError.message);
      setLoadingCourses(false);
      return;
    }

    const { data: cohortData, error: cohortError } = await supabase
      .from("cohorts")
      .select("*")
      .order("start_date", { ascending: true });

    if (cohortError) {
      alert(cohortError.message);
      setLoadingCourses(false);
      return;
    }

    setCourses(courseData || []);
    setCohorts(cohortData || []);
    setLoadingCourses(false);
  };

  useEffect(() => {
    fetchCoursesAndCohorts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdmin]);

  return {
    courses,
    cohorts,
    loadingCourses,
    fetchCoursesAndCohorts,
    createCourse,
    createCohort,
  };
}